/**
 * 稳定 ID 分配器 — 单调递增、永不复用。
 * 状态可序列化，随存档保存/恢复；实体 ID 在加载后继续单调，不与历史冲突。
 */

import type { EntityId, EventRecordId } from '@crater-zero/shared-types';

export interface IdAllocatorState {
  /** 下一个待分配的实体序号。 */
  readonly nextEntity: number;
  /** 下一个待分配的事件记录序号。 */
  readonly nextEventRecord: number;
}

export class IdAllocator {
  private nextEntity: number;
  private nextEventRecord: number;

  private constructor(nextEntity: number, nextEventRecord: number) {
    this.nextEntity = nextEntity;
    this.nextEventRecord = nextEventRecord;
  }

  static create(): IdAllocator {
    return new IdAllocator(1, 1);
  }

  static fromState(state: IdAllocatorState): IdAllocator {
    return new IdAllocator(state.nextEntity, state.nextEventRecord);
  }

  snapshot(): IdAllocatorState {
    return {
      nextEntity: this.nextEntity,
      nextEventRecord: this.nextEventRecord,
    };
  }

  /** 分配一个永不复用的实体 ID。 */
  allocEntity(): EntityId {
    const id = `ent_${this.nextEntity}` as EntityId;
    this.nextEntity += 1;
    return id;
  }

  /** 分配一个事件记录 ID（当前 Tick 内单调）。 */
  allocEventRecord(): EventRecordId {
    const id = `evrec_${this.nextEventRecord}` as EventRecordId;
    this.nextEventRecord += 1;
    return id;
  }
}
